import React from 'react'
import { WebsiteBannersList } from './list/page'

export const WebsiteBannersPage: React.FC = () => {
  return <WebsiteBannersList />
}
